<py-header-navigation-item [url]="{ cxRoute: 'login' } | cxUrl" [ariaLabel]="'navigation.cart_title' | cxTranslate">
  <i class="reset" nz-icon nzType="shopping-cart" nzTheme="outline"></i>
  <span class="navigation-cart-title">{{ 'navigation.cart_title' | cxTranslate }}</span>
</py-header-navigation-item>
